import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="project-support">
          <div className="support-logos">
            <img src="/logo_w.png" alt="ЛингваСаб" className="support-logo" />
            <img src="/support_logo.png" alt="Фонд содействия инновациям" className="support-logo" />
          </div>
          <p className="pencil-text">
            Проект создан при поддержке Федерального государственного бюджетного учреждения Фонд содействия развитию малых форм предприятий в научно-технической сфере в рамках программы «Студенческий стартап» федерального проекта «Платформа университетского технологического предпринимательства»
          </p>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <a href="/privacy" className="legal-link">Политика конфиденциальности</a>
            <a href="/consent" className="legal-link">Согласие на обработку персональных данных</a>
            <a href="/cookies" className="legal-link">Политика cookies</a>
          </div>
          <p className="copyright">
            © {new Date().getFullYear()} ООО «Беляш». Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 